import { render, staticRenderFns } from "./WelcomeBack.vue?vue&type=template&id=87a18ba2&scoped=true&"
import script from "./WelcomeBack.vue?vue&type=script&lang=js&"
export * from "./WelcomeBack.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeBack.vue?vue&type=style&index=0&id=87a18ba2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a18ba2",
  null
  
)

export default component.exports